(function () {
    "use strict";

    /**
     * A toggle switch as an alternative for checkboxes.
     * Based on the material design toggle switch.
     * The switch hooks into the angularjs Form and can be used as a starting point
     * for further form controls
     */

    angular.module("app").directive("habilSwitch", HabilSwitchDirective);

    HabilSwitchDirective.$inject = [];
    function HabilSwitchDirective() {
        return {
            templateUrl: "@/slider/habil-switch.html",
            transclude: true,
            require: { ngModelCtrl: "^ngModel" },
            scope: {},
            link: link
        };

        function link(scope, element, _attributes, ctrl) {
            // The element representing the switch
            const switchElement = element;
            // The NgModelController use for hooking into the angular form
            const ngModelCtrl = ctrl.ngModelCtrl;

            switchElement.on("click", handleClick);

            // #region Value handler

            ngModelCtrl.$render = () => scope.model = ngModelCtrl.$viewValue;
            // External changes
            scope.$watch(function () { return scope.model; }, function (value) {
                ngModelCtrl.$setViewValue(value);
            });

            function handleClick() {
                if (element.attr('disabled')) return;

                scope.model = !scope.model;
                scope.$apply(() => {
                    ngModelCtrl.$setViewValue(scope.model);
                });
            }

            // #endregion
        }
    }
})();
